const USER_DB = "ceoweb-pwa";
const ADMIN_DB = "ceoweb-admin-pwa";
const DB_VERSION = 1;

export const dbNameFor = (appType) => (appType === "admin" ? ADMIN_DB : USER_DB);

export const openPwaDb = (appType = "user") =>
  new Promise((resolve, reject) => {
    if (!("indexedDB" in window)) {
      reject(new Error("indexeddb_unsupported"));
      return;
    }

    const request = window.indexedDB.open(dbNameFor(appType), DB_VERSION);
    request.onupgradeneeded = () => {
      const db = request.result;
      if (!db.objectStoreNames.contains("snapshots")) {
        db.createObjectStore("snapshots", { keyPath: "key" });
      }
      if (!db.objectStoreNames.contains("meta")) {
        db.createObjectStore("meta", { keyPath: "key" });
      }
    };
    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error || new Error("indexeddb_open_failed"));
  });

const requestResult = (request) =>
  new Promise((resolve, reject) => {
    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error || new Error("indexeddb_request_failed"));
  });

export const getMeta = async (db, key) => {
  const record = await requestResult(db.transaction("meta", "readonly").objectStore("meta").get(key));
  return record ? record.value : null;
};

export const setMeta = async (db, key, value) => {
  await requestResult(
    db.transaction("meta", "readwrite").objectStore("meta").put({ key, value })
  );
};

export const putSnapshot = async (db, record) => {
  await requestResult(
    db.transaction("snapshots", "readwrite").objectStore("snapshots").put(record)
  );
};

export const getSnapshot = async (db, key) =>
  requestResult(db.transaction("snapshots", "readonly").objectStore("snapshots").get(key));

export const listSnapshots = async (db) =>
  requestResult(db.transaction("snapshots", "readonly").objectStore("snapshots").getAll());

export const clearPwaData = async (appType = "user") => {
  if ("indexedDB" in window) {
    await new Promise((resolve) => {
      const request = window.indexedDB.deleteDatabase(dbNameFor(appType));
      request.onsuccess = resolve;
      request.onerror = resolve;
      request.onblocked = resolve;
    });
  }

  if ("caches" in window) {
    const prefix = appType === "admin" ? "ceoweb-admin-private-" : "ceoweb-user-private-";
    const names = await window.caches.keys();
    await Promise.all(
      names.filter((name) => name.startsWith(prefix)).map((name) => window.caches.delete(name))
    );
  }

  try {
    window.localStorage.removeItem(`ceoweb_pwa_context_${appType}`);
  } catch (error) {
    // Storage can be unavailable in private browsing modes.
  }
};
